/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Properties_Edit_OrderInputs */

const en_forms_custom_properties_edit_order = /** @type {(inputs: Forms_Custom_Properties_Edit_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const de_forms_custom_properties_edit_order = /** @type {(inputs: Forms_Custom_Properties_Edit_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Forms_Custom_Properties_Edit_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_properties_edit_order = /** @type {((inputs?: Forms_Custom_Properties_Edit_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Properties_Edit_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_properties_edit_order(inputs)
	return de_forms_custom_properties_edit_order(inputs)
});